import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { API_URL } from "../utils/constants";
import { showToast } from "../utils/toast";
import AppHeader from "../Components/AppHeader";
import PasswordInput from "../Components/PasswordInput";
import "./Login.css";
import { useLoginResult } from "../State/LoginResultContext";

export default function ContactReg() {
  
  const { loginResults } = useLoginResult();
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const [organization, setOrganization] = useState({});
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");

  const { organizationId, email } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    verifyMembership();
  }, []);

  const resetErrorState = () => {
    setTimeout(() => {
      setMessage("");
      setIsError(false);
    }, 3000);
  };

  useEffect(() => {
    if (message) {
      showToast(message, { type: isError ? "error" : "success" });
    }
  }, [message, isError]);

  const verifyMembership = async () => {
    try {
      const response = await fetch(`${API_URL}/users/verifyMembership`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          organizationId,
        }),
      });

      const data = await response.json();
      if (response.status === 200) {
        setOrganization(data);
        if(data.userExists){
          setTimeout(() => {
          navigate("/loginregister");
        }, 5000);
        }
      } else {
        setMessage(data.message);
        setIsError(true);
        resetErrorState();
      }
    } catch (error) {
      setMessage(error.message);
      setIsError(true);
      resetErrorState();
    }
  };

  const acceptMembership = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${API_URL}/users/addMembership`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          password,
          organizationId,
          name,
        }),
      });

      const data = await response.json();
      if (response.status === 200) {
        setOrganization({...data, userExists: true});
        showToast("Membership activated. Redirecting to sign in...", { type: "success" });
        setTimeout(() => {
          navigate("/loginregister");
        }, 2000);
      } else {
        setMessage(data.message);
        setIsError(true);
        resetErrorState();
      }
    } catch (error) {
      setMessage(error.message);
      setIsError(true);
      resetErrorState();
    }
  };

  return (
    <div className="min-h-full flex-col">
      <AppHeader className="sm:hidden" isSuperUser={loginResults?.isSuperUser} loginResults={loginResults}/>
      <div className="flex min-h-dvh flex-1 flex-col sm:justify-center px-8 py-2 sm:py-12 sm:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm flex flex-col items-center">
          <img
            src="/logo192.png"
            alt="Seymour Logo"
            className="mx-auto h-11 sm:h-20 w-auto rounded-full hidden sm:block"
          />
          <h1 className="text-center text-[40px] font-extrabold text-white atkinson-font mt-2 tracking-tight">
            Seymour Events
          </h1>
          <h2 className="text-center text-lg sm:text-xl font-extrabold text-white atkinson-font mt-2 px-4">
            {organization.name && `${organization.name} has invited you to collaborate as a member`}
          </h2>
        </div>

        {organization.userExists ? (
          <div className="mt-6 sm:mx-auto sm:w-full sm:max-w-md">
            <div className="text-center">
              <h2 className="text-2xl font-extrabold text-white atkinson-font mb-4">
                Your membership with {organization.name} has been activated.
              </h2>
              <p className="text-white atkinson-font">
                Redirecting to sign in...
              </p>
            </div>
          </div>
        ) : (
          <div className="mt-6 sm:mx-auto sm:w-full sm:max-w-md">
            <form onSubmit={acceptMembership} method="POST" className="space-y-4 sm:space-y-3 m-0">
              <div>
                <label
                  htmlFor="email"
                  className="block text-xl font-bold text-white text-left atkinson-font mb-1 tracking-tight"
                >
                  Email address
                </label>
                <div className="mt-2">
                  <input
                    id="email"
                    name="email"
                    type="email"
                    value={email}
                    readOnly
                    className="block w-full rounded-md border border-[#FFFFFF] py-2 px-3 bg-[#595959] text-[#FFFFFF] text-sm placeholder:text-[#FFFFFFCC] placeholder:text-gray-400 focus:border-[#FFFFFF] focus:ring-0"
                  />
                </div>
              </div>

              <div>
                <label
                  htmlFor="name"
                  className="block text-xl font-bold text-white text-left atkinson-font mb-1 tracking-tight"
                >
                  Full Name
                </label>
                <div className="mt-2">
                  <input
                    id="name"
                    name="name"
                    type="text"
                    onChange={(e) => setName(e.target.value)}
                    value={name}
                    required
                    autoComplete="name"
                    placeholder="Enter your full name"
                    className="block w-full rounded-md border border-[#FFFFFF] py-2 px-3 bg-[#595959] text-[#FFFFFF] text-sm placeholder:text-[#FFFFFFCC] placeholder:text-gray-400 focus:border-[#FFFFFF] focus:ring-0"
                  />
                </div>
              </div>

              <div>
                <label
                  htmlFor="password"
                  className="block text-xl font-bold text-white text-left atkinson-font mb-1 tracking-tight"
                >
                  Password
                </label>
                <div className="mt-2">
                  <PasswordInput
                    id="password"
                    name="password"
                    required
                    autoComplete="new-password"
                    onChange={(e) => setPassword(e.target.value)}
                    value={password}
                    placeholder="Enter your password"
                    className="block w-full rounded-md border border-[#FFFFFF] py-2 px-3 bg-[#595959] text-[#FFFFFF] text-sm placeholder:text-[#FFFFFFCC] placeholder:text-gray-400 focus:border-[#FFFFFF] focus:ring-0"
                  />
                </div>
              </div>

              <div>
                <button
                  type="submit"
                  className="flex w-full justify-center rounded-md !bg-[#5701AE] p-2 text-base font-semibold text-white hover:!bg-[#7A2FD3]"
                  style={{ border: "2px solid #6A6680" }}
                >
                  Accept Invitation
                </button>
              </div>
            </form>
          </div>
        )}
      </div>
    </div>
  );
}
